import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"
import {COARSE, TOUCH_MIN} from "../../../../../theme/modern/touchTargets"

export default makeStyles((theme: ModernTheme) => ({
    pager: {
        flex: "none",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        height: 34,
        padding: "0 12px",
        background: theme.modern.panel,
        borderTop: `1px solid ${theme.modern.line}`,

        [COARSE]: {height: "auto", minHeight: TOUCH_MIN, padding: "4px 10px"},
    },
    btn: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 26,
        height: 24,
        padding: 0,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 6,
        background: theme.modern.panel2,
        color: theme.modern.ink2,
        cursor: "pointer",
        flex: "none",

        "& svg": {width: 12, height: 12},

        "&:hover:not(:disabled)": {color: theme.modern.ink, borderColor: theme.modern.ink3},
        "&:disabled": {opacity: .4, cursor: "default"},
        "&:focus-visible": {outline: `2px solid ${theme.modern.accent}`, outlineOffset: 1},

        [COARSE]: {width: TOUCH_MIN, height: TOUCH_MIN - 6},
    },
    scrub: {
        flex: "1 1 auto",
        minWidth: 80,
        margin: 0,
        height: 24,
        accentColor: theme.modern.accent,
        cursor: "pointer",

        [COARSE]: {height: TOUCH_MIN - 6},
    },
    readout: {
        flex: "none",
        font: `500 12px ${theme.modern.mono}`,
        color: theme.modern.ink,
        whiteSpace: "nowrap",
        fontVariantNumeric: "tabular-nums",
    },
    total: {
        color: theme.modern.ink3,
    },
}))
